// extracted by mini-css-extract-plugin
export var heading = "Highlights-module--heading--a795d";
export var highlightImage = "Highlights-module--highlightImage--0a82b";
export var wrapper = "Highlights-module--wrapper--de40b";